<template>
    <div class="list-card">
        <header>
            <h1>{{ title }}</h1>
            <span>{{ subtitle }}</span>
        </header>

        <div class="list-card__body">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String
            },

            subtitle: {
                type: String
            }
        }
    }
</script>

<style lang="scss" scoped>
@import '@/assets/variables';

    .list-card {
        height: 100%;
        box-shadow: 0 0 20px rgba(17, 25, 28, .2);
        border-radius: 10px;
        border: none;
        

        header {
            background: $main-text-color;
            border-top-left-radius: 0.625rem;
            border-top-right-radius: 0.625rem;

            color: $color-white;

            padding: 1.25rem;

            font-family: "Open Sans";
            font-size: 0.875rem;
            font-weight: 400;

            text-align: center;

            h1 {
                font-size: 1.25rem;
                font-weight: 700;
                letter-spacing: 0.83px;
                text-transform: uppercase;
            }


        }

        &__body {
            padding: 1.875rem;
        }
    }
</style>